import { helpers, utils, query } from '@kurtosys/ksys-app-template';
import { IFactListProps } from '@kurtosys/ksys-app-components/dist/components/fact/FactList/models';
import { AppStoreBase } from './AppStoreBase';
import { IAppComponents } from '../models/IAppComponents';
import { action, computed } from 'mobx';
import { StoreContext } from '../../../configuration/StoreContext';
import { Manifest } from '../../../configuration/Manifest';
import { IFactRedirect } from '../../../models/app/IFactRedirect';
import { IQueryKeyValue } from '@kurtosys/ksys-app-components/dist/models/commonTypes';

const Query = query.Query;
/* [Component: appStoreComponentImport] */

export class AppStore extends AppStoreBase {
	rawUrl: string;

	constructor(element: HTMLElement, url: string, storeContext: StoreContext, manifest: Manifest) {
		super(element, url, storeContext, manifest);
		this.rawUrl = url;
	}

	@computed
	get hasData(): boolean {
		if (this.factListProps) {
			const { itemBlankDataOptions, items } = this.factListProps;
			if (itemBlankDataOptions && itemBlankDataOptions.showBlank) {
				return true;
			}
			const valid = items && items.reduce((hasValues: boolean, item) => {
				let itemValue;
				if (item.riskRatingProps) {
					itemValue = item.riskRatingProps.value;
				}
				else if (item.morningstarRatingProps) {
					itemValue = item.morningstarRatingProps.morningStarRating;
				}
				else {
					itemValue = item.value;
				}
				if (!utils.typeChecks.isNullOrUndefined(itemValue)) {
					hasValues = true;
				}
				return hasValues;
			}, false);
			return valid === true;
		}
		return false;
	}

	@action
	contextsDidUpdateAfter = async () => {
		// TODO: Each Application should put custom logic here to handle changes to the data context
	}

	@computed
	get components(): IAppComponents {
		return {
			/* [Component: appStoreComponent] */
		};
	}

	@computed
	get factRedirects(): IFactRedirect[] | undefined {
		const factRedirects = this.appComponentConfiguration && this.appComponentConfiguration.factRedirects;
		return factRedirects;
	}

	@computed
	get factListProps(): IFactListProps | undefined {
		const factList = this.appComponentConfiguration && this.appComponentConfiguration.factList;
		const factListProps = this.mergeQueriesAndProps(factList) as IFactListProps;
		return this.orchestrateFactRedirects(factListProps);
	}

	orchestrateFactRedirects = (factListProps: IFactListProps | undefined) => {
		const factRedirects = this.factRedirects;
		if (factListProps && factListProps.items && factListProps.items.length > 0 && factRedirects) {
			const redirectsById = utils.collection.pivotCollection(factRedirects, factRedirect => factRedirect.factId || '__NO_FACT_ID');
			factListProps.items.forEach((item) => {
				if (item && item.dataType === 'link' && item.linkProps && item.linkProps.id) {
					const factRedirect = redirectsById[item.linkProps.id];
					if (factRedirect) {
						const { redirect, inputs: redirectInputs = [] } = factRedirect;
						if (redirect) {
							const redirectHelper = new helpers.RedirectHelper(this.rawUrl);
							const { queryStore } = this.storeContext;
							const inputQueriesByKey = redirectInputs.reduce((redirectConfigInputs, inputConfig) => {
								if (!redirectConfigInputs[inputConfig.key]) {
									redirectConfigInputs[inputConfig.key] = inputConfig.query;
								}
								return redirectConfigInputs;
							}, {} as IQueryKeyValue);

							const inputs = Query.convertQueryKeyValue(inputQueriesByKey || {}, queryStore.executionOptions);
							const redirectPath = redirectHelper.getRedirectPath(redirect, inputs);
							if (!item.linkProps) {
								item.linkProps = {};
							}
							item.linkProps.href = redirectPath;
						}
					}
				}
			});
		}
		return factListProps;
	}

	async customInitializeAfter() {

	}
}